// extracted by mini-css-extract-plugin
module.exports = {"container":"BosSideBar_container__39Jmo","headingBox":"BosSideBar_headingBox__RgSRg"};